export const API_URL = process.env.NODE_ENV === 'production'
    ? 'https://banakh.com' // when will be domen
    : 'http://localhost:7000';
export const PRICE_ONE_PHOTO = 3;